"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _ArrowDropDown2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _FormControl2 = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Select2 = _interopRequireDefault(require("@material-ui/core/Select"));

var _Flag2 = _interopRequireDefault(require("@material-ui/icons/Flag"));

var _ThumbUp2 = _interopRequireDefault(require("@material-ui/icons/ThumbUp"));

var _Favorite2 = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _StarRounded2 = _interopRequireDefault(require("@material-ui/icons/StarRounded"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("../../propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Rating = function Rating(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      getStyles = _ref.getStyles,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      setOptions = _ref.setOptions;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      defaultRate = _useState4[0],
      setDefaultRate = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      rateStyle = _useState6[0],
      setRateStyle = _useState6[1];

  var maxRate = options.max || 5;

  var ratingStyle = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!getStyles) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return getStyles("rating");

            case 3:
              result = _context.sent;
              setRateStyle(result);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function ratingStyle() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    ratingStyle();
    defaultRateType(style === null || style === void 0 ? void 0 : style.id, style === null || style === void 0 ? void 0 : style.type, style === null || style === void 0 ? void 0 : style.color);
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      max: maxRate
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var defaultRateType = function defaultRateType(id, type, color) {
    switch (type) {
      case "star":
        setDefaultRate( /*#__PURE__*/_react["default"].createElement(_StarRounded2["default"], {
          style: {
            color: color
          }
        }));
        break;

      case "heart":
        setDefaultRate( /*#__PURE__*/_react["default"].createElement(_Favorite2["default"], {
          style: {
            color: color
          }
        }));
        break;

      case "like":
        setDefaultRate( /*#__PURE__*/_react["default"].createElement(_ThumbUp2["default"], {
          style: {
            color: color
          }
        }));
        break;

      case "flag":
        setDefaultRate( /*#__PURE__*/_react["default"].createElement(_Flag2["default"], {
          style: {
            color: color
          }
        }));
        break;

      default:
        setDefaultRate( /*#__PURE__*/_react["default"].createElement(_StarRounded2["default"], {
          style: {
            color: "#f82b60"
          }
        }));
        break;
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: "1rem",
      fontSize: "0.875rem",
      marginTop: "1rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 500
    }
  }, "Max"), /*#__PURE__*/_react["default"].createElement(_FormControl2["default"], {
    style: {
      marginTop: "0.25rem"
    },
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_Select2["default"], {
    "native": true,
    style: {
      minHeight: 50
    },
    onChange: function onChange(e) {
      return setOptions(_objectSpread(_objectSpread({}, options), {}, {
        max: Number(e.target.value)
      }));
    },
    value: maxRate
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: 1
  }, "1"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 2
  }, "2"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 3
  }, "3"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 4
  }, "4"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 5
  }, "5"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 6
  }, "6"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 7
  }, "7"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 8
  }, "8"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 9
  }, "9"), /*#__PURE__*/_react["default"].createElement("option", {
    value: 10
  }, "10")))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 500
    }
  }, "Style"), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      marginTop: "0.25rem",
      display: "inline-flex",
      borderRadius: "0.25rem",
      justifyContent: "center",
      alignItems: "center",
      border: "2px solid rgba(0,0,0,0.1)",
      padding: "0.25rem",
      cursor: "pointer",
      minHeight: 50
    },
    onClick: function onClick(e) {
      return setAnchorEl(e.currentTarget);
    }
  }, defaultRate, /*#__PURE__*/_react["default"].createElement(_ArrowDropDown2["default"], {
    style: {
      marginLeft: "0.25rem",
      color: "#757575"
    }
  })), /*#__PURE__*/_react["default"].createElement(_Menu2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    variant: "menu",
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    style: {
      height: 360
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: "0.25rem",
      paddingBottom: "0.25rem",
      paddingLeft: "0.75rem",
      paddingRight: "0.75rem",
      display: "grid",
      gridTemplateColumns: "repeat(".concat(5, ", minmax(0, 1fr))"),
      gap: "1rem"
    }
  }, rateStyle === null || rateStyle === void 0 ? void 0 : rateStyle.map(function (item) {
    var iconType = null;

    switch (item.type) {
      case "star":
        iconType = /*#__PURE__*/_react["default"].createElement(_StarRounded2["default"], {
          style: {
            color: item.color
          }
        });
        break;

      case "heart":
        iconType = /*#__PURE__*/_react["default"].createElement(_Favorite2["default"], {
          style: {
            color: item.color
          }
        });
        break;

      case "like":
        iconType = /*#__PURE__*/_react["default"].createElement(_ThumbUp2["default"], {
          style: {
            color: item.color
          }
        });
        break;

      case "flag":
        iconType = /*#__PURE__*/_react["default"].createElement(_Flag2["default"], {
          style: {
            color: item.color
          }
        });
        break;

      default:
        break;
    }

    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      key: item.id,
      style: {
        cursor: "pointer"
      },
      onClick: function onClick() {
        defaultRateType(item.id, item.type, item.color);
        setAnchorEl(null);
        setOptions(_objectSpread(_objectSpread({}, options), {}, {
          style: item.id
        }));
      }
    }, iconType);
  }))))));
};

Rating.propTypes = _propTypes.OptionProps;
var _default = Rating;
exports["default"] = _default;